<mat-dialog-content style="height: 73vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <div class="mod-container" style="margin-top: 20px;">
            <table style="width: 100%;">
                <tr>
                    <td style="width:20%;">
                        <mat-form-field style="width: 100%;">
                            <input matInput placeholder="Búsqueda de prestación"
                                [(ngModel)]="txtBusquedaPrestacion" autocomplete="off"
                                (keydown.Enter)="buscarPrestacion()" >
                        </mat-form-field>
                    </td>
                    <td style="width: 5%;">
                        <i class="fas fa-search" style="width: 10px; margin-right: 20px;
                            font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                            margin-top: 0px; margin-right: 20px;" (click)="buscarPrestacion()"
                            matTooltip="Buscar prestación">
                        </i>
                    </td>
                    <td *ngIf="lblPrestacionActual==''" style="width: 75%;"></td>
                    <td *ngIf="lblPrestacionActual!=''" style="width: 75%;">
                        <h4><strong>{{lblPrestacionActual}}</strong></h4>
                    </td> 
                </tr>
            </table>
            <table style="width: 100%;">
                <tr>
                    <td style="width:30%;">
                        <mat-form-field style=" width: 95%;">
                            <input matInput placeholder="Codigo del prestador"
                                [(ngModel)]="txtCodigoPrestador" autocomplete="off">
                        </mat-form-field>
                    </td>
                    <td style="width: 5%;"></td>
                    <td style="width:65%;">
                        <mat-form-field style=" width: 95%;">
                            <input matInput placeholder="Nombre de la prestación para el prestador"
                                [(ngModel)]="txtNombrePrestador" autocomplete="off">
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <mat-checkbox style="margin-bottom: 20px; margin-top: 10px; margin-right: 20px;" color="primary"
                [(ngModel)]=chkHabilitada>Habilitada
            </mat-checkbox>
            <mat-checkbox style="margin-bottom: 20px; margin-top: 10px;" color="primary"
                [(ngModel)]=chkPorPresupuesto>Por presupuesto
            </mat-checkbox>
            <table style="width: 100%;" [hidden]="chkPorPresupuesto">
                <tr>
                    <td style="width: 45%;">
                        <mat-form-field appearance="fill" style="width: 100%;">
                            <mat-label>Tipo de coseguro</mat-label>
                            <mat-select [(ngModel)]="tipoCoseguro">
                            <mat-option value="PUEDEMODIFICAR">Se puede modificar al recepcionar</mat-option>
                            <mat-option value="NOMODIFICAR">No se puede modificar al recepcionar</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                    <td style="width: 25%;">
                        <mat-form-field style="width: 90%; margin-left: 5%;">
                            <input matInput placeholder="Coseguro" autocomplete="off"
                            soloNumerosComaPunto [(ngModel)]=txtImporteCoseguro>
                        </mat-form-field>
                    </td>
                    <td style="width: 5%;"></td>
                    <td style="width: 20%;">
                        <mat-form-field style="width: 95%;">
                            <input matInput placeholder="Importe a la OS" autocomplete="off"
                            soloNumerosComaPunto [(ngModel)]=txtImporteOS>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
